import i18n from 'utils/i18n'
import Form from 'components/molecules/Form'
import HelperSetting from 'utils/helper-setting'
import { privacyOptions, settingsConstants } from 'utils/constants/settings-constants'
import _ from 'lodash'
import Translate from 'utils/translate'
import { ThemedSizes, ThemedValues } from 'styles/themed'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ThemedBlock from 'components/atoms/ThemedBlock'
import React, { useEffect, useState } from 'react'
import HelperPlatform from 'utils/helper-platform'
import * as ImagePicker from 'expo-image-picker'
import { StyleSheet, Keyboard, View } from 'react-native'
import * as ImageManipulator from 'expo-image-manipulator'
import EmployeeUtil from 'utils/employee-util'
import HelperString from 'utils/helper-string'
import FetchCachedTeam from 'utils/fetch/cached/FetchCachedTeam'
import FetchCachedDepartment from 'utils/fetch/cached/FetchCachedDepartment'
import FetchCachedJobtitle from 'utils/fetch/cached/FetchCachedJobtitle'
import LoadingComponent from 'components/atoms/Loading'
import EmployeeCard, { EmployeeCardModes } from "components/molecules/EmployeeCard";
import HelperAlerts from 'utils/HelperAlerts'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import ObjectClass from 'utils/objects/object'
import { TESTID } from '_shared/config/testID'
import { transportList } from 'utils/constants/transport-constants'

const EmployeeData = ({ employee, saveForm, reload }) => {
	
	const [ uploading, setUploading ] = useState( false )
	const [ loading, setLoading ] = useState( true )
	const [ teams, setTeams ] = useState( [] )
	const [ departments, setDepartments ] = useState( [] )
	const [ jobtitles, setJobtitles ] = useState( [] )
	
	const employeeExists = _.get( employee, 'guid', null ) !== null;
	
	const getPermissionAsync = async ( ) => {
		if ( HelperPlatform.isNotWeb() ) {
			const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
			
			if (status !== 'granted') {
				HelperAlerts.alert(
					i18n.t('page.profile.no_roll_permission')
				);
			} else {
				await pickImage();
			}
		} else {
			await pickImage();
		}
	};
	
	const pickImage = async () => {
		setUploading( true )
		
		try {
			const result = await ImagePicker.launchImageLibraryAsync( {
				mediaTypes: ImagePicker.MediaTypeOptions.Images,
				allowsEditing: true,
				aspect: [ 1, 1 ],
				quality: 1,
				//base64: true,
				exif: false
			} );
			
			if ( !result.cancelled ) {
				// Resize the image
				const manipResult = await ImageManipulator.manipulateAsync(
					result.uri,
					[
						{ resize: {
								width: 1000
							} }
					],
					{
						compress: 0.8,
						format: ImageManipulator.SaveFormat.JPEG,
						base64: true
					}
				);
				
				uploadImage( manipResult.base64 );
			} else {
				setUploading( false  )
			}
		} catch ( E ) {
			setUploading( false  )
		}
	};
	
	const uploadImage = ( base64Data ) => {
		const guid = _.get( employee, 'guid', '' );
		
		EmployeeUtil.uploadImage( base64Data, guid, {
			onSuccess: result => {
				reload({ loading: false });
				
				setUploading( false )
			},
			onError: result => {
				setUploading( false )
			}
		});
	}
	
	const fetchTeam = () => {
		FetchCachedTeam.fetchAll({
			callbackSuccess: ({ teams }) => {
				setTeams( _.sortBy( teams, 'name' ) )
				
				fetchDepartments()
			}
		})
	}
	
	const fetchDepartments = () => {
		FetchCachedDepartment.fetchAll({
			callbackSuccess: ({ departments }) => {
				setDepartments( _.sortBy( departments, 'name' ) )
				
				fetchJobtitles()
			}
		})
	}
	
	const fetchJobtitles = () => {
		FetchCachedJobtitle.fetchAll({
			callbackSuccess: ({ jobtitles }) => {
				setJobtitles( _.sortBy( jobtitles, 'name' ) )
				
				setLoading( false )
			}
		})
	}
	
	useEffect( () => {
		return fetchTeam();
	}, [] )
	
	const teamOptions = [];
	_.forEach( teams, ( team ) => {
		if( ObjectClass.isActive( team ) ) {
			teamOptions.push({
				value:   team.guid,
				label: Translate.field( team, 'title' )
			})
		}
	});
	
	const jobtitleOptions = [];
	_.forEach( jobtitles, ( jobtitle ) => {
		if( ObjectClass.isActive( jobtitle ) ) {
			jobtitleOptions.push( {
				value: jobtitle.guid,
				label: Translate.field( jobtitle, 'title' )
			} )
		}
	});
	
	const departmentOptions = [];
	_.forEach( departments, ( department ) => {
		if( ObjectClass.isActive( department ) ) {
			const company = _.get( department, 'company', { name: 'Unknown company' } );
			
			const departmentName = Translate.field( department, 'title' );
			let companyName = Translate.field( company, 'title' );
			
			if( departmentName !== null ) {
				let label = departmentName;
				
				if( companyName == '' ) {
					companyName = '[Unknown company]';
				}
				
				if( companyName !== null && _.includes( label, companyName ) === false ) {
					label = `${companyName} - ${label}`;
				}
				
				departmentOptions.push( {
					value: department.guid,
					label: label
				} );
			}
		}
	});
	
	const formFields = [
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		},
		{
			name: 'external_id',
			label: i18n.t('management:form.external_id.title'),
			type: FormFieldsConstants.TEXT
		},
		{
			type: FormFieldsConstants.TITLE,
			label: i18n.t( 'management:form.titles.personal')
		},
		{
			name: 'name',
			required: true,
			label: i18n.t('management:form.name.title'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'email',
			required: true,
			label: i18n.t('management:form.email.title'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'phonenumber',
			label: i18n.t('management:form.phonenumber.title'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'landline_phonenumber',
			label: i18n.t('management:form.landline_phonenumber.title'),
			type: FormFieldsConstants.TEXT,
		},
		
		{
			name: 'response_employee',
			label: i18n.t('management:form.response_employee.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		},
		{
			name: 'confidant',
			label: i18n.t('management:form.confidant.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		}
	];
	
	if( HelperSetting.isYes( settingsConstants.PROFILE_ENABLE_ACCESS_CARD_ID_EDITING ) ) {
		formFields.push({
			name: 'access_card_id',
			label: i18n.t('form.fields.access_card_id.title'),
			type: FormFieldsConstants.TEXT
		})
	}
	
	if( HelperSetting.isYes( settingsConstants.COMMUTE_ENABLE ) ) {
		formFields.push({
			type: FormFieldsConstants.TITLE,
			label: i18n.t( 'management:form.titles.commute')
		});
		formFields.push({
			name: 'transport_kind',
			label: i18n.t('form.fields.transport_kind.title'),
			hint: i18n.t('form.fields.transport_kind.description'),
			type: FormFieldsConstants.SELECT,
			options: _.map( transportList, name => {
				return (
					{
						value: name,
						label: i18n.t(`basic.transport.kind.${ name }`)
					}
				);
			})
		});
		formFields.push({
			name: 'license_plate',
			label: i18n.t('form.fields.license_plate.title'),
			type: FormFieldsConstants.TEXT,
			props: {
				returnKeyType: 'done',
				onSubmitEditing: Keyboard.dismiss,
				testID: TESTID.HOME.MORE.PROFILE.LICENSE_PLATE_INPUT
			}
		});
		formFields.push({
			name: 'address_postal_code',
			label: i18n.t('management:form.address_postal_code.title'),
			type: FormFieldsConstants.ADDRESS,
		});
	}
	
	if( _.size( teamOptions ) > 0 || _.size( jobtitleOptions ) > 0 || _.size( departmentOptions ) > 0 ){
		formFields.push({
			type: FormFieldsConstants.TITLE,
			label: i18n.t( 'management:form.titles.company')
		});
		
		if( _.size( teamOptions ) > 0 ) {
			formFields.push({
				name: 'team_guid',
				label: i18n.t('management:form.teams.title'),
				type: FormFieldsConstants.SELECT,
				options: teamOptions
			});
		}
		
		if( _.size( jobtitleOptions ) > 0 ) {
			formFields.push({
				name: 'jobtitle_guid',
				label: i18n.t('management:form.jobtitles.title'),
				type: FormFieldsConstants.SELECT,
				options: jobtitleOptions
			});
		}
		
		if( _.size(departmentOptions ) > 0 ) {
			formFields.push({
				name: 'department_guid',
				label: i18n.t('management:form.departments.title'),
				type: FormFieldsConstants.SELECT,
				options: departmentOptions
			});
		}
	}
	
	formFields.push({
		type: FormFieldsConstants.TITLE,
		label: i18n.t( 'management:form.titles.privacy')
	});
	
	formFields.push({
		name: 'visible_for_employees',
		label: i18n.t('management:form.visible_for_employees.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});
	
	// show favourites
	if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) ) {
		const showFavouriteOptions = [
			{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_phonenumber.values.no') },
			{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_phonenumber.values.team') }
		];
		
		if( !HelperSetting.isYes( settingsConstants.COWORKER_FAVOURITE_ONLY_FROM_TEAM ) ) {
			showFavouriteOptions.push( { value: privacyOptions.EVERYBODY, label: i18n.t( 'form.fields.show_phonenumber.values.company') } );
		}
		
		//
		formFields.push({
			name: 'show_favourite',
			label: i18n.t('form.fields.show_favourite.title'),
			type: FormFieldsConstants.SELECT,
			options: showFavouriteOptions
		});
	}
	
	// show phonenumber
	if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) && HelperSetting.isYes( settingsConstants.COWORKER_SHOW_PHONENUMBER ) ) {
		const showPhonenumberOptions = [
			{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_phonenumber.values.no') },
			{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_phonenumber.values.team') },
		];
		
		if( !HelperSetting.isYes( settingsConstants.COWORKER_PHONENUMBER_ONLY_FROM_TEAM ) ) {
			showPhonenumberOptions.push( { value: privacyOptions.EVERYBODY, label: i18n.t( 'form.fields.show_phonenumber.values.company') } );
		}
		
		formFields.push({
			name: 'show_phonenumber',
			label: i18n.t('form.fields.show_phonenumber.title'),
			type: FormFieldsConstants.SELECT,
			options: showPhonenumberOptions
		});
	}
	
	// show calendar
	if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) ) {
		const showCalendarOptions = [
			{ value: privacyOptions.NO, label: i18n.t( 'form.fields.show_calendar.values.no') },
			{ value: privacyOptions.TEAM, label: i18n.t( 'form.fields.show_calendar.values.team') }
		];
		
		//
		if( !HelperSetting.isYes( settingsConstants.COWORKER_CALENDER_ONLY_FROM_TEAM ) ) {
			showCalendarOptions.push( { value: privacyOptions.EVERYBODY, label: i18n.t( 'form.fields.show_calendar.values.company') } );
		}
		
		// show phonenumber
		formFields.push({
			name: 'show_calendar',
			label: i18n.t('form.fields.show_calendar.title'),
			type: FormFieldsConstants.SELECT,
			options: showCalendarOptions
		});
	}
	
	formFields.push({
		type: FormFieldsConstants.TITLE,
		label: i18n.t( 'management:form.titles.app_rights')
	});
	formFields.push({
		name: 'can_scan_presence_qr_code',
		label: i18n.t('management:form.can_scan_presence_qr_code.title'),
		type: FormFieldsConstants.SELECT_ACTIVE,
	});
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}
	
	return (
		<ThemedBlock
			header={ i18n.t('management:form_block.title_default') }
			shadow
			mediumPadding>
			
			{/* Image */}
			{ employeeExists && (
				<View>
					<EmployeeCard
						key={ HelperString.hash('render-item-avatar', employee ) }
						mode={EmployeeCardModes.avatar}
						employee={ employee }
						avatarSize={ ThemedSizes.L }
						avatarStyle={ staticStyles.employeeCardMarginBottomMarginVertical }
						avatarLoading={ uploading }
						onPress={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.EMPLOYEES ) ? getPermissionAsync : null }
					/>
				</View>
			)}
			
			<Form
				values={{
					...employee,
					transport_kind: _.get( employee, ['transport_kind'] ),
					license_plate: _.get( employee, ['license_plate'] ),
					address_postal_code: _.get( employee, ['address', 'postal_code'] ),
				}}
				fields={ formFields }
				onSubmit={ saveForm }
				disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.EMPLOYEES ) }
			/>
		</ThemedBlock>
	)
}

const staticStyles = StyleSheet.create({
	employeeCardMarginBottomMarginVertical: {
		marginBottom: ThemedValues.marginVertical,
	},
});

export default EmployeeData
